"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncyclopediaEntityType = void 0;
/**
 * @hidden
 */
var EncyclopediaEntityType;
(function (EncyclopediaEntityType) {
    EncyclopediaEntityType["ENTITY"] = "ENTITY";
    EncyclopediaEntityType["LOCATION"] = "LOCATION";
    EncyclopediaEntityType["ARTIFACT"] = "ARTIFACT";
    EncyclopediaEntityType["EVENT"] = "EVENT";
    EncyclopediaEntityType["CONCEPT"] = "CONCEPT";
    EncyclopediaEntityType["OTHER"] = "OTHER";
})(EncyclopediaEntityType = exports.EncyclopediaEntityType || (exports.EncyclopediaEntityType = {}));
